import { SM_TILT_MODULE_LENGTH_ORIENTATION_LIMIT } from '__common/constants/modules';
import { isSMTilt } from '__common/constants/products';
import { apiField as smClampsChoicesApiField } from 'projectDesign/components/projectConfiguration/fields/smClamps';

const SM_TILT_LONG_MODULE_CLAMP_WARNING = 'Module Length above 84.42" can only have Pro and UAF Clamps';

export const getWarningMessageFactory = (state: appState) =>
  (fieldName: string) => {
    const { projectConfiguration: { productId, formState }, moduleSelector: { modelData } } = state;
    const warningFields = formState?.warningFields ?? [];

    if (fieldName === smClampsChoicesApiField && isSMTilt(productId)) {
      const invalid = (formState?.invalidFields ?? []).some(f => f.fieldName === fieldName);
      if (!invalid && Number(modelData?.height) > SM_TILT_MODULE_LENGTH_ORIENTATION_LIMIT) {
        return warningFields.find(f => f.fieldName === fieldName)?.warningMessage || SM_TILT_LONG_MODULE_CLAMP_WARNING;
      }
      return null;
    }

    const field = warningFields.find(f => f.fieldName === fieldName);
    if (field) {
      return field.warningMessage;
    }

    return null;
  };
